module.exports = __webpack_public_path__ + "img/book.be5030ca.webp";